import React from "react";
import PropTypes from "prop-types";
import queryToUrl from "../../../Srp/helpers/queryToUrl";
import classes from "./styles.module.scss";

const PageLink = ({ page, href, loadPage, isCurrent }) => {
  if (isCurrent || !href)
    return <span className={classes.CurrentPage}>{page}</span>;

  return (
    <a
      href={href}
      className="srp-page-link"
      data-ga={`srp_goto_page_${page}`}
      onClick={(e) => {
        e.preventDefault();
        loadPage(page);
      }}
    >
      {page}
    </a>
  );
};

PageLink.propTypes = {
  page: PropTypes.number.isRequired,
  href: PropTypes.string,
  loadPage: PropTypes.func.isRequired,
  isCurrent: PropTypes.bool.isRequired,
};

const PageList = ({ currentPage, totalPages, loadedPages, loadPage, query }) =>
  new Array(totalPages).fill(undefined).map((_, i) => {
    const page = i + 1;
    if (
      page === 1 ||
      page === totalPages ||
      (page > currentPage - 2 && page < currentPage + 2) ||
      loadedPages.includes(page)
    ) {
      return (
        <PageLink
          key={i}
          href={
            typeof query === "string"
              ? query
              : page === currentPage
              ? null
              : queryToUrl({ ...query, page })
          }
          page={page}
          loadPage={loadPage}
          isCurrent={page === currentPage}
        />
      );
    }

    if (
      page === currentPage - 2 ||
      page === currentPage + 2 ||
      page === loadedPages[loadedPages.length - 1] + 1
    ) {
      return (
        <span key={i} className={classes.Ellipsis}>
          &hellip;
        </span>
      );
    }

    return null;
  });

PageList.propTypes = {
  currentPage: PropTypes.number.isRequired,
  totalPages: PropTypes.number.isRequired,
  loadedPages: PropTypes.arrayOf(PropTypes.number).isRequired,
  loadPage: PropTypes.func.isRequired,
  query: PropTypes.oneOfType([PropTypes.object, PropTypes.string]).isRequired,
};

export default PageList;
